import { Box, Typography, styled } from "@mui/material";

const ProgressBar = styled(Box)<{ active?: boolean }>(({ theme, active }) => ({
  flex: 1,
  height: 4,
  borderRadius: 2,
  backgroundColor: active
    ? theme.palette.primary.main
    : theme.palette.grey[300],
}));

interface IOnboardingProgressProps {
  stepNumber: number;
  totalSteps: number;
}

function OnboardingProgress({
  stepNumber,
  totalSteps,
}: IOnboardingProgressProps) {
  return (
    <Box>
      <Typography
        variant="overline"
        sx={{
          letterSpacing: 1.2,
          fontWeight: 600,
          color: "text.secondary",
        }}
      >
        Step {stepNumber} of {totalSteps}
      </Typography>
      <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
        {Array.from({ length: totalSteps }).map((_, i) => (
          <ProgressBar key={i} active={i < stepNumber} />
        ))}
      </Box>
    </Box>
  );
}

export default OnboardingProgress;
